// removes null attributes from objects
function removeEmpty(obj) {
  // eslint-disable-next-line no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== null));
}

// removes undefined and null attributes from objects
function removeUndefinedAndNull(obj) {
  // eslint-disable-next-line no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null));
}

export { removeEmpty, removeUndefinedAndNull };
